var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessInformationVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8 3.5H3.39999C2.36906 3.5 1.53333 4.33574 1.53333 5.36667V32.4333C1.53333 33.4643 2.36906 34.3 3.39999 34.3H25.8C26.8309 34.3 27.6667 33.4643 27.6667 32.4333V5.36667C27.6667 4.33574 26.8309 3.5 25.8 3.5Z",
    fill: "#00E2BC",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5999 0.700195H7.13327C6.10234 0.700195 5.2666 1.53593 5.2666 2.56686V29.6335C5.2666 30.6645 6.10234 31.5002 7.13327 31.5002H28.5999C29.6309 31.5002 30.4666 30.6645 30.4666 29.6335V2.56686C30.4666 1.53593 29.6309 0.700195 28.5999 0.700195Z",
    fill: "#F2F8FC",
    stroke: "#0A78CD",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0297 21.9258H24.6364",
    stroke: "#0A78CD",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0297 24.71H24.6364",
    stroke: "#0A78CD",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.0297 27.5781H24.6364",
    stroke: "#0A78CD",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.621 11.6533H20.0465C20.3465 11.6533 20.5903 11.8971 20.5903 12.1971V17.1816H16.0752V12.1971C16.0752 11.8971 16.319 11.6533 16.619 11.6533H16.621Z",
    fill: "#00E2BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.5775 15.0725C19.8008 15.0725 19.9819 14.8914 19.9819 14.6681C19.9819 14.4447 19.8008 14.2637 19.5775 14.2637C19.3541 14.2637 19.173 14.4447 19.173 14.6681C19.173 14.8914 19.3541 15.0725 19.5775 15.0725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.5591 17.6826H24.1091C24.4009 17.6826 24.6375 17.4461 24.6375 17.1544V8.51267C24.6375 8.22092 24.4009 7.98442 24.1091 7.98442L12.5591 7.98442C12.2673 7.98442 12.0307 8.22092 12.0307 8.51267L12.0307 17.1544C12.0307 17.4461 12.2673 17.6826 12.5591 17.6826Z",
    stroke: "#0A78CD",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.5812 5.47852C11.3296 5.47852 11.109 5.64686 11.0413 5.88873L10.2574 8.70802C10.2845 9.79936 11.1767 10.674 12.276 10.674C13.3753 10.674 14.2655 9.79743 14.2945 8.70802H14.2965C14.3236 9.79936 15.2158 10.674 16.315 10.674C17.4143 10.674 18.3045 9.79743 18.3336 8.70802H18.3355C18.3626 9.79936 19.2548 10.674 20.3541 10.674C21.4533 10.674 22.3436 9.79743 22.3726 8.70802H22.3745C22.4016 9.79936 23.2938 10.674 24.3931 10.674C25.4924 10.674 26.3826 9.79743 26.4116 8.70802L25.6278 5.88873C25.5601 5.64686 25.3395 5.47852 25.0879 5.47852H11.5812Z",
    fill: "#00E2BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M10.7374 8.64062H25.9201",
    stroke: "white",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessInformationVerificationIcon);
export default __webpack_public_path__ + "static/media/BusinessInformationVerificationIcon.d890c8aaab2ee8a373150b9d87f4f633.svg";
export { ForwardRef as ReactComponent };